import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { _chatMessages } from 'store/selectors/Chat'

import { ChatPreviewContainer } from './styles'
import TextMessageView from './TextMessageView'

const ChatPreview = ({ handleClick }) => {
    const stateMessages = useSelector(_chatMessages)
    const messages = stateMessages.slice(-2)
    const [shouldShow, setShouldShow] = useState(true)

    /*
     * isContinued : If the present message's sender is the same as the previous message's sender
     * If consecutive messages have the same sender we dont want to show profile image again
     */

    useEffect(() => {
        if (stateMessages.length > 0) {
            setShouldShow(true)
            setTimeout(() => {
                setShouldShow(false)
            }, 4000)
        }
    }, [stateMessages.length])

    const getIsContinued = index => {
        return (
            index > 0 &&
            messages[index - 1].senderUid === messages[index].senderUid
        )
    }

    const renderMessageView = (message, index) => {
        const isContinued = getIsContinued(index)
        message = { ...message, isSelf: false }
        switch (message.type) {
            case 'text':
                return (
                    <TextMessageView
                        key={index}
                        message={message}
                        isContinued={isContinued}
                    />
                )
            case 'gesture':
                return (
                    <TextMessageView
                        key={index}
                        message={message}
                        isContinued={isContinued}
                        isGesture={true}
                    />
                )

            default:
                return null
        }
    }

    return (
        <ChatPreviewContainer shouldShow={shouldShow} onClick={handleClick}>
            {messages.map((message, index) =>
                renderMessageView(message, index)
            )}
        </ChatPreviewContainer>
    )
}

export default React.memo(ChatPreview)
